<template>
	<div>
		<div v-if="loading" class="dynvibeLoading"></div>
		<div v-if="!loading && noData" class="noData">
			<p>No Data to display</p>
		</div>
		<highcharts v-if="!loading && !noData" class="highcharts-container" ref="chartComponent" :options="chartOptions"></highcharts>
	</div>
</template>

<script>
export default {
	name: "SpiderWeb",
	data() {
		return {
			loading: false,
			noData: false,
			allseries: {},
			countries: [
				["FR", "France"],
				["US", "USA"],
				["UK", "United Kingdom"],
				["ES", "Spain"],
			],
			date: {
				gte: "",
				lte: "",
			},
			data: {},
			front: false,
		};
	},
	computed: {
		chartOptions: function () {
			return {
				chart: {
					polar: true,
					type: "area",
					spacingLeft: 50,
				},

				accessibility: {},

				title: {
					text: "Categories Seasonality",
					x: -80,
				},

				pane: {
					size: "80%",
				},

				xAxis: {
					categories: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
					tickmarkPlacement: "on",
					lineWidth: 0,
				},

				yAxis: {
					gridLineInterpolation: "polygon",
					lineWidth: 0,
					min: 0,
				},

				tooltip: {
					shared: true,
					pointFormat: '<span style="color:{series.color}">{series.name}: <b>{point.y:,.0f} Posts</b><br/>',
				},

				legend: {
					align: "right",
					verticalAlign: "middle",
					layout: "vertical",
				},

				series: [
					{
						name: "Sports",
						data: [43000, 19000, 60000, 35000, 17000, 10000, 43000, 19000, 60000, 35000, 17000, 10000],
						pointPlacement: "on",
					},
					{
						name: "Food",
						data: [50000, 39000, 42000, 31000, 26000, 14000, 43000, 19000, 60000, 35000, 17000, 10000],
						pointPlacement: "on",
					},
					{
						name: "Health",
						data: [20000, 49000, 42000, 3000, 2600, 1400, 43000, 19000, 6000, 3500, 17300, 25000],
						pointPlacement: "on",
					},
				],

				responsive: {
					rules: [
						{
							condition: {
								maxWidth: 500,
							},
							chartOptions: {
								legend: {
									align: "center",
									verticalAlign: "bottom",
									layout: "horizontal",
								},
								pane: {
									size: "70%",
								},
							},
						},
					],
				},
			};
		},
	},
	mounted: function () {},
	watch: {
		panel() {
			this.checkFilters();
		},
		segment() {
			this.checkFilters();
		},
		date: {
			deep: true,
			handler() {
				this.checkFilters();
			},
		},
		country() {
			this.checkFilters();
		},
		category() {
			this.checkFilters();
		},
		subcategory() {
			this.checkFilters();
		},
		mastertag() {
			this.checkFilters();
		},
		"$store.state.parameters": function () {
			this.date = this.$store.getters.parameters.date;
		},
	},
};
</script>

<style></style>
